export function filesize(initialSize) {
  let size = initialSize;
  if (Number.isNaN(size)) {
    size = 0;
  }

  if (size < 1024) {
    return `${size} B`;
  }

  size /= 1024;

  if (size < 1024) {
    return `${size.toFixed(2)} KB`;
  }

  size /= 1024;

  if (size < 1024) {
    return `${size.toFixed(2)} MB`;
  }

  size /= 1024;

  return `${size.toFixed(2)} GB`;
}

export function truncate(str, length = 10) {
  if (str.length > length && (str.length - length) > 3) {
    const tailSize = Math.floor(length / 2);
    const pivot = str.length - tailSize;
    const strStart = str.substring(0, tailSize);
    const strEnd = str.substring(pivot);

    return `${strStart}...${strEnd}`;
  }
  return str;
}
